export default __webpack_public_path__ + "src/assets/telegram.6333a621ccb71c8ccf8ab4541b7e9bd7.svg";